/**
 * Generate "min-width" media query string from a given theme.
 *
 * @example
 * const MyComponent = styled.div(({ theme }) => ({
 *   fontSize: theme.sizes.m,
 *
 *   [minWidthFromTheme(theme).mobile]: {
 *     fontSize: theme.sizes.s
 *   }
 * }))
 *
 * @example
 * const MyComponent = styled.div`
 *   font-size: ${({ theme }) => theme.sizes.m};
 *
 *   ${({ theme }) => minWidthFromTheme(theme).mobile} {
 *     font-size: ${({ theme }) => theme.sizes.s};
 *   }
 * `
 */
var minWidthFromTheme = function minWidthFromTheme(theme) {
  return {
    mobile: "@media (min-width: ".concat(theme.breakpoints.smallMobile, ")"),
    tablet: "@media (min-width: ".concat(theme.breakpoints.mobile, ")"),
    desktop: "@media (min-width: ".concat(theme.breakpoints.tablet, ")"),
    largeDesktop: "@media (min-width: ".concat(theme.breakpoints.desktop, ")"),
    xLargeDesktop: "@media (min-width: ".concat(theme.breakpoints.largeDesktop, ")")
  };
};
/**
 * Generate "max-width" media query string from a given theme.
 *
 * @example
 * const MyComponent = styled.div(({ theme }) => ({
 *   fontSize: theme.sizes.s,
 *
 *   [maxWidthFromTheme(theme).smallMobile]: {
 *     fontSize: theme.sizes.m
 *   }
 * }))
 *
 * @example
 * const MyComponent = styled.div`
 *   font-size: ${({ theme }) => theme.sizes.s};
 *
 *   ${({ theme }) => maxWidthFromTheme(theme).smallMobile} {
 *     font-size: ${({ theme }) => theme.sizes.m};
 *   }
 * `
 */

var maxWidthFromTheme = function maxWidthFromTheme(theme) {
  return {
    smallMobile: "@media (max-width: calc(".concat(theme.breakpoints.smallMobile, " - 1px))"),
    mobile: "@media (max-width: calc(".concat(theme.breakpoints.mobile, " - 1px))"),
    tablet: "@media (max-width: calc(".concat(theme.breakpoints.tablet, " - 1px))"),
    desktop: "@media (max-width: calc(".concat(theme.breakpoints.desktop, " - 1px))"),
    largeDesktop: "@media (max-width: calc(".concat(theme.breakpoints.largeDesktop, " - 1px))")
  };
};

export { maxWidthFromTheme, minWidthFromTheme };
//# sourceMappingURL=media-query.js.map
